import { Component, OnInit, ElementRef, Renderer2, ViewChild, Inject } from '@angular/core';
import { DatePipe } from '@angular/common';
import { ApiservicesService } from '../../apiservices.service';
import { Router } from '@angular/router';
import { EncryptdecryptService } from '../../services/encryptdecrypt.service';
import { APP_CONFIG, AppConfig } from '../../app-config';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css'],
  providers: [DatePipe]
})
export class HeaderComponent implements OnInit {
  hideSearchBar = true;
  CurrentDate: any;
  DateOption: any;
  TotalAppointted: Number = 0;
  MyTaxAddress: string = ""; // Make available to HTML

  constructor(
    private router: Router, 
    private datePipe: DatePipe, 
    private apiServices: ApiservicesService, 
    private encryptDecryptService: EncryptdecryptService,
    @Inject(APP_CONFIG) private config: AppConfig
  ) { 
    this.MyTaxAddress = config.MyTaxAddress; // Load from config
  }

  ngOnInit(): void {
    this.DateOption = { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' };
    this.CurrentDate = new Date(Date.now());
    this.CurrentDate = this.CurrentDate.toLocaleString('ms-MY', this.DateOption);
    this.GetTotal();
  }

  Logout() {
    sessionStorage.removeItem('StaffIDType');
    sessionStorage.removeItem('StaffIDNo');
    sessionStorage.removeItem('FirmID');
    sessionStorage.removeItem('StaffID');
    sessionStorage.clear();

    window.location.href = this.MyTaxAddress; // Use config value
  }

  async GetTotal() {
    let Params = {
      "FirmID": Number(this.encryptDecryptService.decrypt(sessionStorage.getItem('FirmID') || '')),
      "TaxAgentID": Number(this.encryptDecryptService.decrypt(sessionStorage.getItem('TaxAgentID') || ''))
    };
    const result = await this.apiServices.GetTotalAppointed(Params);
    this.TotalAppointted = result;
  }

  GoToApointted() {
    this.router.navigate(['/penerimaan-pelantikan-permohonan-online']);
  }
}
